<template>
  <div :class="['input-lable', { 'input-lable': label }]">
    <div v-if="label" class="title">
      <label>{{ label }}</label>
    </div>
    <a-select
      v-model="input"
      show-search
      :class="[{ readOnly, 'input-enum': !label }]"
      :placeholder="placeholder"
      :disabled="disabled || readOnly"
      :allowClear="allowClear"
      :size="size"
      @change="onChange"
      @search="onSearch"
    >
      <a-icon v-if="icon" slot="suffixIcon" :type="icon" />
      <a-select-option v-for="option of options" :key="option">
        <component-prepare-date v-if="type === 'date'" :timestamp="Number(option)" />
        <span v-else>{{ option }}</span>
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  name: 'InputEnum',
  components: {
    ComponentPrepareDate: () => import('@/pages/processing/components/PrepareDate.vue'),
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: undefined,
    },
    size: {
      type: String,
      default: 'default',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    input: {
      get() {
        return this.value || undefined;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    placeholder() {
      return this.disabled || this.readOnly ? '' : 'Выберите';
    },
  },
  methods: {
    onChange(value) {
      this.$emit('change', value);
    },
    onSearch(value){
     this.$emit('search', value);
    }
  },
};
</script>

<style lang="scss">
.input-lable {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 1.6rem;
  font-weight: 600;
  height: inherit;
  border-radius: $borderRadius;

  .title {
    display: flex;
    font-size: 1.4rem;
    flex: none;

    label {
      margin-right: 1.6rem;
    }

    &:after {
      content: '';
      display: block;
      width: 2px;
      margin-right: 0.6rem;
      border-right: 2px solid #ebf1f8;
    }
  }

  .ant-select {
    width: 100%;
    &-open svg {
      transform: none;
    }
  }

  .ant-select-selection {
    display: flex;
    align-items: center;
    padding-left: 1rem;
    border: none;
    overflow: hidden;
    height: auto;

    .ant-select-selection__rendered {
      margin: 0;
      line-height: normal;
      width: 100%;
      padding-right: 55px;
    }
  }

  &.readOnly {
    color: inherit;

    .ant-select-selection {
      background: #fff;
      cursor: text;
      user-select: initial;
    }

    .ant-select-arrow {
      cursor: not-allowed;
    }
  }
}

.input-enum {
  width: 100%;
  height: inherit;

  .ant-select-selection {
    height: inherit;
    padding: 1.6rem;
    display: flex;
    align-items: center;
    border: none;
    overflow: hidden;

    .ant-select-selection__rendered {
      margin: 0;
      line-height: normal;
      width: 100%;
    }
  }

  &.readOnly {
    color: inherit;

    .ant-select-selection {
      background: #fff;
      cursor: text;
      user-select: initial;
    }

    .ant-select-arrow {
      cursor: not-allowed;
    }
  }
}
</style>
